import { TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Autocomplete } from '@material-ui/lab';
import {
  dark as darkColors,
  light as lightColors,
  secondary
} from 'shared/theme/colorTokens';

const useStyles = makeStyles((theme) => {
  const isDark = theme.palette.type === 'dark';
  const colors = isDark ? darkColors : lightColors;
  return {
    field: {
      '& .MuiOutlinedInput-root': {
        borderRadius: 8,
        backgroundColor: colors.surface,
        '& fieldset': {
          borderColor: colors.border
        },
        '&:hover fieldset': {
          borderColor: colors.borderHover
        },
        '&.Mui-focused fieldset': {
          borderColor: lightColors.accent,
          borderWidth: 1
        }
      },
      '& .MuiInputBase-input': {
        color: colors.textPrimary,
        fontSize: 14
      }
    },
    paper: {
      borderRadius: 12,
      backgroundColor: theme.palette.background.paper
    },
    option: {
      fontSize: 14,
      '&[data-focus="true"]': {
        backgroundColor: colors.accentSoft
      },
      '&[aria-selected="true"]': {
        backgroundColor: colors.accentSoftStrong,
        color: isDark ? secondary[300] : secondary[600]
      }
    }
  };
});

interface Props<T> {
  options: T[];
  value: T | null;
  getOptionLabel: (option: T) => string;
  onChange: (value: T | null) => void;
  onBlur?: () => void;
  placeholder: string;
  disabled?: boolean;
}

function StyledAutocomplete<T>({
  options,
  value,
  getOptionLabel,
  onChange,
  onBlur,
  placeholder,
  disabled = false
}: Props<T>) {
  const classes = useStyles();

  return (
    <Autocomplete
      size="small"
      options={options}
      disabled={disabled}
      value={value}
      getOptionLabel={getOptionLabel}
      onChange={(_, newValue) => onChange(newValue)}
      onBlur={onBlur}
      classes={{ paper: classes.paper, option: classes.option }}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={placeholder}
          variant="outlined"
          className={classes.field}
          disabled={disabled}
        />
      )}
    />
  );
}

export default StyledAutocomplete;
